export default "__VITE_ASSET__DFO9ZX7Q__"